import { createContext } from 'react'
import type { LogFilterProviderState } from '@/components/shared/log-filters/types'

const initialState: LogFilterProviderState = {
  filters: [],
  setFilters: () => null,
  isCollapsed: false,
  setIsCollapsed: () => null,
}

export const LogFilterProviderContext =
  createContext<LogFilterProviderState>(initialState)
